module.exports = __webpack_public_path__ + "static/preview-image-eabce346bb4765bc909ad06ef3da0d40.png";